import React from 'react';

import Icon from '@components/icon/Icon';

interface HorizontalStepperProps {
  steps: { label: string }[];
  currentStep: number;
  className?: string;
}

const HorizontalStepper = ({
  steps,
  currentStep,
  className
}: HorizontalStepperProps) => (
  <div className={`flex w-full items-start ${className ?? ''}`}>
    {steps.map((step, index) => {
      const isCompleted = index < currentStep;
      const isActive = index === currentStep;

      return (
        <React.Fragment key={step.label}>
          <div className="relative flex flex-col items-center px-1">
            <div
              className={`
                flex size-6 shrink-0
                items-center justify-center rounded-full border
                ${
                  isActive
                    ? 'border-cofeePrimary3 bg-cofeePrimary2'
                    : 'border-cofeeGreyBlue3 bg-cofeeGreyBlue3'
                }
              `}
            >
              {isCompleted ? (
                <Icon name="stepper-completed" />
              ) : (
                <span
                  className={`
                    size-2 rounded-full
                    ${isActive ? 'bg-cofeePrimary6' : 'bg-cofeeGreyBlue7'}
                  `}
                />
              )}
            </div>

            <span className="absolute left-1/2 top-8 -translate-x-1/2 whitespace-nowrap text-sm font-medium text-cofeeNeutral10">
              {step.label}
            </span>
          </div>

          {index !== steps.length - 1 && (
            <div
              className={`
                mt-[11px] h-1 flex-1 rounded-lg
                ${isCompleted ? 'bg-cofeePrimary6' : 'bg-cofeeGreyBlue5'}
              `}
            />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default HorizontalStepper;
